import { FC } from 'react';

export const ErrorBoundary: FC = () => {
  return <div>Some thing went wrong, please refresh the page</div>;
};
